import { Builder, Image as BuilderImage } from "@builder.io/react";
import { StaticImage } from "gatsby-plugin-image";
import { useState } from "react";
import { Gallery, Item } from "react-photoswipe-gallery";
import { toMutable } from "types/common";
import glass from "./images/glass.svg";
import * as styles from "./styles.module.scss";

const inputs = [
    {
        name: "title",
        type: "text",
        defaultValue: "We Support Greener Traffic With Lower Cost",
    },
    {
        name: "subtitle",
        type: "longText",
        defaultValue: "Introducing AY’s unique QPS optimization solution",
    },
    {
        name: "text1",
        type: "text",
        defaultValue: "Double or Triple your results by understanding the demand behind each user",
    },
    {
        name: "text2",
        type: "longText",
        defaultValue:
            "The traffic shaping decisioning is based on a frequently trained machine learning ensemble combining the strengths from Gradient Boosting and Neural Nets as seen in most of the top kaggle.com submissions.",
    },
    {
        name: "text3",
        type: "longText",
        defaultValue:
            "The AI performance is enforced with the creation of user profiles in real time, which greatly improves the accuracy of the predictions further. This is done in a very resource-efficient way.",
    },
    {
        name: "hideText",
        type: "longText",
        defaultValue:
            "This results in the system outperforming the leading vendor on the market by nearly 100%. When compared with in-house solutions and other vendors it is likely to compare even better.",
    },
    {
        name: "hideBoldText",
        type: "text",
        defaultValue: "Winning SSPs can now reach new heights of revenue from DSPs.",
    },
    {
        name: "hideText2",
        type: "longText",
        defaultValue:
            "Incredibly high RPS (thousands per core), low memory consumption (400 MB), and fast response times (microseconds).",
    },
    {
        name: "switchMagnifier",
        type: "boolean",
        defaultValue: true,
        enum: [
            {
                value: true,
                label: "Yes",
            },
            {
                value: false,
                label: "No",
            },
        ],
    },
    {
        name: "imageOrGif",
        type: "file",
        allowedFileTypes: ["jpg", "png", "jpeg", "gif", "svg"],
    },
    {
        name: "imageOrGifHover",
        type: "file",
        allowedFileTypes: ["jpg", "png", "jpeg", "gif", "svg"],
    },
    {
        name: "imageOrGifAlt",
        type: "text",
        defaultValue: "Gain Bidder Intelligence",
    },
    {
        name: "imageOrGifWidth",
        type: "number",
        defaultValue: 1161,
    },
    {
        name: "imageOrGifHeight",
        type: "number",
        defaultValue: 714,
    },
] as const;

const ByCompanyTypeWeSupportGreenerTraffic: BFC<typeof inputs> = ({
    title,
    subtitle,
    text1,
    text2,
    text3,
    hideText,
    hideBoldText,
    hideText2,
    switchMagnifier,
    imageOrGif,
    imageOrGifHover,
    imageOrGifAlt,
    imageOrGifWidth,
    imageOrGifHeight,
}) => {
    const [showMore, setShowMore] = useState(false);

    return (
        <>
            <div className="component-wrapper">
                <div className="container ">
                    <div className={`${styles.firstGlow} gradient`}>
                        <StaticImage src="./images/by-company-type-data-is-power-first-glow.svg" alt="" />
                    </div>
                    <div className="row align-items-start gx-5">
                        <div className="col-lg-6 order-lg-1 mt-4 mb-4 mt-lg-0 mb-lg-0">
                            <div className="mask-container  position-relative ">
                                {imageOrGifHover ? (
                                    <img
                                        onMouseOver={e => {
                                            e.currentTarget.src = imageOrGifHover;
                                        }}
                                        onMouseOut={e => {
                                            e.currentTarget.src = imageOrGif!;
                                        }}
                                        src={imageOrGif}
                                        alt={imageOrGifAlt}
                                        className="img-fluid"
                                    />
                                ) : (
                                    //@ts-ignore
                                    <BuilderImage image={imageOrGif} lazy sizes="100%" altText={imageOrGifAlt} />
                                )}
                                {switchMagnifier && !imageOrGifHover && (
                                    <Gallery>
                                        <Item
                                            width={imageOrGifWidth}
                                            height={imageOrGifHeight}
                                            original={imageOrGif}
                                            alt={imageOrGifAlt}
                                        >
                                            {({ ref, open }) => (
                                                // @ts-expect-error
                                                <div className="image_mask" ref={ref} onClick={open}>
                                                    <img src={glass} alt="zoom image" />
                                                </div>
                                            )}
                                        </Item>
                                    </Gallery>
                                )}
                            </div>
                        </div>

                        <div className="col-lg-6 order-2 order-lg-1 mt-5 mt-lg-0">
                            <h2>{title}</h2>
                            <p>{subtitle}</p>
                            <p>{text1}</p>
                            <p>{text2}</p>
                            <p>{text3}</p>
                            {showMore && (
                                <div className={styles.fadeInDown}>
                                    <p>{hideText}</p>
                                    <p className="font-weight-bold">{hideBoldText}</p>
                                    <p>{hideText2}</p>
                                </div>
                            )}
                            {!showMore && (
                                <div onClick={() => setShowMore(true)} className={styles.showMoreWrapper}>
                                    <div className={styles.showMoreIcon}>
                                        <StaticImage src="./images/by-company-type-data-is-power-icon-add.svg" alt="" />
                                    </div>
                                    <p className={styles.showMoreText}>Show more</p>
                                </div>
                            )}

                            {showMore && (
                                <div onClick={() => setShowMore(false)} className={styles.showMoreWrapper}>
                                    <div className={styles.showMoreIcon}>
                                        <StaticImage
                                            src="./images/by-company-type-data-is-power-icon-remove.svg"
                                            alt=""
                                        />
                                    </div>
                                    <p className={styles.showMoreText}>Show less</p>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

Builder.registerComponent(ByCompanyTypeWeSupportGreenerTraffic, {
    name: "byCompanyTypeWeSupportGreenerTraffic",
    inputs: toMutable(inputs),
});
